import { render, staticRenderFns } from "./ImageResize.vue?vue&type=template&id=5358bc90&scoped=true"
import script from "./ImageResize.vue?vue&type=script&lang=js"
export * from "./ImageResize.vue?vue&type=script&lang=js"
import style0 from "./ImageResize.vue?vue&type=style&index=0&id=5358bc90&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5358bc90",
  null
  
)

export default component.exports